export default __webpack_public_path__ + "static/media/heartNav.ace48a28.svg";